// Reserved screen names (QA_2026-11-03 NT-034). A screen name appears publicly as
// "by <name>" on community content and in share-invite email subjects sent from
// NeatTick's own SES identity, so brand and staff-role names are not allowed.
import { SYSTEM_USER_SUB } from "./types.js";

const LOOKALIKES: Record<string, string> = {
  "0": "o", "1": "i", "3": "e", "4": "a", "5": "s", "7": "t", "8": "b",
  "@": "a", "$": "s", "|": "i", "!": "i", l: "i",
};

/** Comparison key: NFKD, lower case, look-alikes folded, letters a-z only. */
export function screenNameKey(raw: string): string {
  let out = "";
  for (const ch of raw.normalize("NFKD").toLowerCase()) {
    const mapped = LOOKALIKES[ch] ?? ch;
    if (mapped >= "a" && mapped <= "z") out += mapped;
  }
  return out;
}

/** Reserved anywhere in the name ("NeatTick Support"). */
const BRAND_TERMS = ["neattick", "eggblox"];
/** Reserved as the whole name, optionally followed by a number ("admin2"). */
const ROLE_NAMES = [
  "admin", "administrator", "support", "staff", "moderator", "mod", "system",
  "official", "help", "helpdesk", "security", "root", "team",
];
const BRAND_KEYS = BRAND_TERMS.map(screenNameKey);
const ROLE_KEYS = new Set(ROLE_NAMES.map(screenNameKey));

export function isReservedScreenName(raw: string): boolean {
  const key = screenNameKey(raw);
  if (!key) return false;
  if (BRAND_KEYS.some((term) => key.includes(term))) return true;
  return ROLE_KEYS.has(screenNameKey(raw.replace(/[\s._-]*\d+$/, "")));
}

/** Content owned by the seeded SYSTEM user is NeatTick's own (D6). */
export function isOfficialOwner(ownerId: string | undefined): boolean {
  return ownerId === SYSTEM_USER_SUB;
}
